import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useProctorGroups } from '@indeed/frontend-proctor-utils';
import { DqPastAnswersPage } from './DqPastAnswersPage';
import { SqPastAnswersPage } from './SqPastAnswersPage';
import { isDqPrefillEnabled } from '../../../lib/proctor/isDqPrefillEnabled';

export { useShouldIncludeHostedSQ } from './SqPastAnswersPage';

/** Selects the SQ or DQ data source while both reuse the same Past Answers UI. */
const PastAnswersPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const { getGroup } = useProctorGroups();
    const isDqPageEnabled = isDqPrefillEnabled(getGroup);

    return searchParams.get('questionType') === 'dq' && isDqPageEnabled ? (
        <DqPastAnswersPage />
    ) : (
        <SqPastAnswersPage />
    );
};

export default PastAnswersPage;
